/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fac_CalloutInputs */

const en_fac_callout = /** @type {(inputs: Fac_CalloutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For design-thinking coaches, capstone lecturers, agencies —`)
};

const id_fac_callout = /** @type {(inputs: Fac_CalloutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk pelatih design thinking, dosen capstone, agensi —`)
};

/**
* | output |
* | --- |
* | "For design-thinking coaches, capstone lecturers, agencies —" |
*
* @param {Fac_CalloutInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fac_callout = /** @type {((inputs?: Fac_CalloutInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fac_CalloutInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fac_callout(inputs)
	return en_fac_callout(inputs)
});